import React, { useState } from 'react';
import axios from "axios";
import MakeBannerButton from "./MakeBannerButton";
import { defaultVariables } from "../../../../../config";
import GetConfirmationText from "../../../../components/elements/GetConfirmationText";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {useTranslation} from "react-i18next";
import {getMediaURL} from "../../../../../config/values";
import {Trash} from "lucide-react";
import {CheckBoxRounded} from "@mui/icons-material";

const SlideShowItem = ({ item, reload, model,position,page }) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();


    const onDelete = async (id) => {
        const data = new FormData();
        data.append('id', id);
        setLoading(true);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/banners/delete`, data, config);
            reload();
        } catch (error) {
            console.error(error.response);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="slide_show_item banner_item">
            <img
                src={getMediaURL(item.desktop_image)}
                alt="thumbnail"
            />
            <div className="controller">
                <GetConfirmationText
                    tooltip={t('remove')}
                    handleAction={() => onDelete(item.id)}
                    icon={<CheckBoxRounded/>}
                    size="small"
                    iconColor="primary"
                >
                    <Trash className="lucide-icon-primary btn"/>
                </GetConfirmationText>
                <MakeBannerButton
                    page={page}
                    position={position}
                    id={item.id}
                    reload={reload}
                    model={model}
                />
            </div>
        </div>
    );
};

export default SlideShowItem;
